// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"16444fbb","77":"548b636f","223":"40535fe2","242":"bf620c54","327":"e548bf32","451":"0fd037a0","453":"9b8e55e1","476":"78bffd41","602":"e8a94af3","620":"4f894acf","737":"80666bfb","807":"046bdc4d"}[chunkId] + ".chunk.js";
};